import { Typography } from '@mui/material';
import { OnBackgroundText } from 'features/ui';

type PageTitleProps = {
  title: string;
  fontSize: number;
  /** Truncate rather than wrap — handled inside the plate, never on the `h1`. */
  noWrap?: boolean;
};

/** The single page `h1`, plated because it sits on the patterned background.
 *  An empty title keeps its line box and turns invisible, so the header does
 *  not resize while the route resolves. `minWidth: 0` lets the heading shrink
 *  below its content width where it is a flex item, which is what allows a
 *  `noWrap` plate to truncate instead of pushing its row siblings out. */
export const PageTitle = ({
  title,
  fontSize,
  noWrap = false,
}: PageTitleProps) => (
  <Typography
    component="h1"
    sx={{
      fontSize,
      fontWeight: 700,
      letterSpacing: '-0.02em',
      minWidth: 0,
      visibility: title.length > 0 ? 'visible' : 'hidden',
    }}
  >
    <OnBackgroundText noWrap={noWrap}>{title}</OnBackgroundText>
  </Typography>
);
